// INTERNAL
export const UPDATE_LATENCY=1000;

// EXTERNAL
export const RELEASE_TAG    = process.env.REACT_APP_RELEASE_TAG || 'vX.Y.Z';
export const VERSION        = process.env.REACT_APP_VERSION || 'n/a';
export const ACTIVE_PROFILE = process.env.REACT_APP_ACTIVE_PROFILE || 'test';
export const RETAILER = process.env.REACT_APP_RETAILER || '';

const PROTOCOL = parseInt(process.env.REACT_APP_TLS || 1, 10) ? 'https' : 'http';

const API_HOST  = process.env.REACT_APP_API_HOST  ||'test-api.getdabbl.com';
const AUTH_HOST = process.env.REACT_APP_AUTH_HOST ||'test-auth.getdabbl.com';

export const API_URL  = `${PROTOCOL}://${API_HOST}:${process.env.REACT_APP_API_PORT || 443}`;
export const AUTH_URL = `${PROTOCOL}://${AUTH_HOST}:${process.env.REACT_APP_AUTH_PORT || 443}`;

export const APPLICATION_ID     = process.env.REACT_APP_APPLICATION_ID || 'mynfo_consumer';
export const APPLICATION_SECRET = process.env.REACT_APP_APPLICATION_SECRET || '77a512a1-2315-43dd-9491-6ce8869cae9d';

export const RETAILER_ID = process.env.REACT_APP_RETAILER_ID || '4d6e5533-e91c-4254-b020-0a1048d706de';

export const SSO_REDIRECT_URL = process.env.REACT_APP_RETAILER === 'freshgrocer' ?
    (ACTIVE_PROFILE === 'prod' ? 'https://www.thefreshgrocer.com/loginredirect?RedirectUrl=/downtimedollars'
    : 'https://www.staging.thefreshgrocer.com/loginredirect?RedirectUrl=/downtimedollars')
    : (ACTIVE_PROFILE === 'prod' ? 'https://preview.shoprite.com/loginredirect?RedirectUrl=/downtimedollars'
        : 'https://preview.staging.shoprite.com/loginredirect?RedirectUrl=/downtimedollars')
        //'https://secure.shoprite.com/User/SignIn/3601?returnUrl=https%3A%2F%2Fwww.priceritemarketplace.com%2Fdowntimedollars'

// Stage retailerId = 4d6e5533-e91c-4254-b020-0a1048d706de
// Demo  retailerId = 4d6e5533-e91c-4254-b020-0a1048d706de
// Test  retailerId = 4d6e5533-e91c-4254-b020-0a1048d706de
// Prod  retailerId = 6d8cbdda-b021-4417-81e9-2c5524258824


// WEBPACK FOOTER //
// ./src/config.js